import React, { useEffect, useState } from "react";
import { allApi } from "../apiwrapper/api";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import AgentChatBot from "./Chatbot/AgentChatBot";
import io from "socket.io-client";
const socket = io(process.env.REACT_APP_API_BACKEND_URL);

function ChatbotHumanDash() {
  const [chatBotTicketsData, setChatBotTicketsData] = useState({
    active_tickets: { tickets: [] },
    inactive_tickets: { tickets: [] },
  });

  console.log("chatBotTicketsData", chatBotTicketsData);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [ticketView, setTicketView] = useState("open"); // "open" or "closed"
  const [activePage, setActivePage] = useState(1);
  const [inactivePage, setInactivePage] = useState(1);

  let { session_id, chatbot_id } = useParams();
  const userID = useSelector((state) => state?.user?.data?._id);

  useEffect(() => {
    getChatBotMessages();
  }, []);

  useEffect(() => {
    getChatBotMessages();
  }, [activePage, inactivePage]);

  const getChatBotMessages = async () => {
    setIsLoading(true);
    try {
      const response = await allApi({
        url: `${process.env.REACT_APP_API_BACKEND_URL}/get-ticket?user_id=${userID}&active_page=${activePage}&inactive_page=${inactivePage}`,
        method: "GET",
        headers: { "Content-Type": "application/json" },
        formData: false,
      });

      const data = response?.data;
      setChatBotTicketsData({
        active_tickets: data?.active_tickets || { tickets: [] },
        inactive_tickets: data?.inactive_tickets || { tickets: [] },
      });
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Filter tickets based on toggle
  const filteredTickets =
    ticketView === "open"
      ? chatBotTicketsData.active_tickets.tickets
      : chatBotTicketsData.inactive_tickets.tickets;

  return (
    <main>
      <section className="training-materials">
        <div className="container-fluid">
          <div className="row">
            {/* Ticket Sidebar */}
            <div className="col-md-4 border-end">
              <div className="open-tickets bg-light overflow-scroll tickets-scroll p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  {/* <div className="d-flex justify-content-between align-items-center mb-3"> */}
                  <h3 className="m-0">
                    {ticketView === "open" ? "Open Tickets" : "Closed Tickets"}
                  </h3>
                  <div
                    className="btn-group border rounded-pill bg-white shadow-sm"
                    role="group"
                    style={{ overflow: "hidden" }}
                  >
                    <button
                      className={`btn btn-sm ${
                        ticketView === "open"
                          ? "btn-primary text-white"
                          : "btn-light text-secondary"
                      }`}
                      style={{
                        borderRadius: "20px 0 0 20px",
                        fontWeight: 500,
                        padding: "5px 15px",
                        border: "none",
                      }}
                      onClick={() => setTicketView("open")}
                    >
                      Open
                    </button>
                    <button
                      className={`btn btn-sm ${
                        ticketView === "closed"
                          ? "btn-primary text-white"
                          : "btn-light text-secondary"
                      }`}
                      style={{
                        borderRadius: "0 20px 20px 0",
                        fontWeight: 500,
                        padding: "5px 15px",
                        border: "none",
                      }}
                      onClick={() => setTicketView("closed")}
                    >
                      Closed
                    </button>
                    {/* </div> */}
                  </div>
                </div>

                {isLoading && <p>Loading tickets...</p>}
                {error && <p className="text-danger">{error}</p>}
                {!isLoading && filteredTickets.length === 0 && (
                  <p>No {ticketView} tickets found.</p>
                )}

                {filteredTickets.map((ticket, index) => (
                  // console.log("TICKET", ticket)
                  <div key={index} className="open-ticket border-top mt-2 p-2">
                    <p>
                      <strong>Ticket #{ticket?.ticket_id}</strong>
                    </p>
                    <p>
                      Status:{" "}
                      {ticket.active_status === "true" ? "OPEN" : "CLOSED"}
                    </p>
                    <p>Subject: {ticket.ticket_issue}</p>
                    <Link
                      to={`/agentdash/${ticket.session_id}/${ticket.chatbot_id}`}
                      className="btn btn-primary btn-sm"
                    >
                      View Details
                    </Link>
                  </div>
                ))}

                <div className="d-flex justify-content-between mt-3">
                  <button
                    className="btn btn-outline-primary btn-sm"
                    disabled={
                      ticketView === "open"
                        ? activePage === 1
                        : inactivePage === 1
                    }
                    onClick={() =>
                      ticketView === "open"
                        ? setActivePage((prev) => Math.max(prev - 1, 1))
                        : setInactivePage((prev) => Math.max(prev - 1, 1))
                    }
                  >
                    Previous
                  </button>

                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() =>
                      ticketView === "open"
                        ? setActivePage((prev) => prev + 1)
                        : setInactivePage((prev) => prev + 1)
                    }
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>

            {/* Chatbot Area */}
            <div className="col-md-4 border-end">
              {session_id && (
                <AgentChatBot
                  session_id={session_id}
                  chatbot_id={chatbot_id}
                  socket={socket}
                />
              )}
            </div>

            {/* Related Details */}
            <div className="col-md-4">
              <div className="related-details bg-light p-3">
                <h3>Related Details</h3>
                <div className="related-detail">
                  <h3>Ticket #123</h3>
                  <p>Status: Open</p>
                  <p>Priority: High</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default ChatbotHumanDash;
